import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { Login, PasswordRecovery } from '../../pages'

export const PublicRouter = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/password-recovery/:id" element={<PasswordRecovery />} />
    <Route path="*" element={<Navigate to="/login" />} />
  </Routes>
)
